import {
  BusinessForm,
  ExistingState,
  SignupFormStatus,
  SpouseParticipation
} from "api/sdk"

export const businessFormLabels: Record<BusinessForm, string> = {
  [BusinessForm.LLC]: "LLC",
  [BusinessForm.C]: "C Corporation",
  [BusinessForm.S]: "S Corporation",
  [BusinessForm.Sole]: "Sole Proprietorship",
  [BusinessForm.Partnership]: "Partnership"
}

export const existingStateLabels: Record<ExistingState, string> = {
  [ExistingState.None]: "No existing plan",
  [ExistingState.Both]: "Keep both plans",
  [ExistingState.Replace]: "Replace the existing plan"
}

export const spouseParticipationLabels: Record<SpouseParticipation, string> = {
  [SpouseParticipation.NotApplicable]: "N/A",
  [SpouseParticipation.Participating]: "Yes, spouse will participate",
  [SpouseParticipation.NotParticipating]: "No, spouse will not participate"
}

export const signupFormStatusLabels: Record<SignupFormStatus, string> = {
  [SignupFormStatus.Approved]: "Approved",
  [SignupFormStatus.ChangesRequested]: "Changes Requested",
  [SignupFormStatus.Rejected]: "Rejected"
}
